import React, {useMemo} from 'react';
import dayjs from "dayjs";
import {getErrorLogColumns} from "./columns/errorLogColumns";
import LogTemplate from "./LogTemplate";
import GoToUserInfoButton from "../../shared/components/buttons/GoToUserInfoButton";

const ErrorLog = () => {
    const defaultSearchParams = {
        begin: dayjs().subtract(7, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        end: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
        logType: 'error_log',
        isUnix: false
    };

    const columns = useMemo(() => ([
        ...getErrorLogColumns(true),
        {
            title: '유저 정보',
            dataIndex: 'pid',
            render: (pid) => <GoToUserInfoButton pid={pid}/>,
        },
    ]), []);

    return (
        <LogTemplate
            columns={columns}
            defaultSearchParams={defaultSearchParams}
            routerUrl={'/logs/error'}
            logName={'ErrorLog'}
            searchParamVisible={true}
        />
    );
};

export default ErrorLog;